export const REGION_TO_KLADR = {
    'MOW': '77',
    'SPE': '78',
    'SEV': '92',
    'AD': '01',
    'AL': '04',
    'BA': '02',
    'BU': '03',
    'DA': '05',
    'IN': '06',
    'KB': '07',
    'KL': '08',
    'KC': '09',
    'KR': '10',
    'KO': '11',
    'CR': '91',
    'ME': '12',
    'MO': '13',
    'SA': '14',
    'SE': '15',
    'TAT': '16',
    'TY': '17',
    'UD': '18',
    'KK': '19',
    'CE': '20',
    'CU': '21',
    'ALT': '22',
    'KDA': '23',
    'KYA': '24',
    'PRI': '25',
    'STA': '26',
    'KHA': '27',
    'AMU': '28',
    'ARK': '29',
    'AST': '30',
    'BEL': '31',
    'BRY': '32',
    'VLA': '33',
    'VGG': '34',
    'VLG': '35',
    'VOR': '36',
    'IVA': '37',
    'IRK': '38',
    'KGD': '39',
    'KLU': '40',
    'KAM': '41',
    'KEM': '42',
    'KIR': '43',
    'KOS': '44',
    'KGN': '45',
    'KRS': '46',
    'LEN': '47',
    'LIP': '48',
    'MAG': '49',
    'MOS': '50',
    'MUR': '51',
    'NIZ': '52',
    'NGR': '53',
    'NVS': '54',
    'OMS': '55',
    'ORE': '56',
    'ORL': '57',
    'PNZ': '58',
    'PER': '59',
    'PSK': '60',
    'ROS': '61',
    'RYA': '62',
    'SAM': '63',
    'SAR': '64',
    'SAK': '65',
    'SVE': '66',
    'SMO': '67',
    'TAM': '68',
    'TVE': '69',
    'TOM': '70',
    'TUL': '71',
    'TYU': '72',
    'ULY': '73',
    'CHE': '74',
    'ZAB': '75',
    'YAR': '76',
    'YEV': '79',
    'NEN': '83',
    'KHM': '86',
    'CHU': '87',
    'YAN': '89',
    'DPR': '80',
    'LPR': '81',
    'ZAP': '85',
    'KHE': '84',
};

export const DEFAULT_KLADR_CODE = '77';

const GEO_PREFIX = '@@geolocation/';

export const GEO_ACTION_TYPES = {
    REQUEST_LOCATION: `${GEO_PREFIX}REQUEST_LOCATION`,
    RECEIVE_LOCATION: `${GEO_PREFIX}RECEIVE_LOCATION`,
    LOCATION_ERROR: `${GEO_PREFIX}LOCATION_ERROR`,
    SET_REGION: `${GEO_PREFIX}SET_REGION`,
    SET_CITY: `${GEO_PREFIX}SET_CITY`,
    LOAD_FROM_STORAGE: `${GEO_PREFIX}LOAD_FROM_STORAGE`,
};

export const GEO_FIELD_NAMES = {
    REGION: 'region',
    REGION_CODE: 'regionCode',
    CITY: 'city',
    COUNTRY: 'country',
    COUNTRY_CODE: 'countryCode',
    LATITUDE: 'latitude',
    LONGITUDE: 'longitude',
    TIMEZONE: 'timezone',
    ISP: 'isp',
};